/** @file SHAKE_WAVE_DEFAULT: the shake wave a host gets without `PoseParams.shakeWave` (22.3 b). */
import type { ShakeWave } from '@zilo/pose3d-pose/contract';

/** 60 Hz clock steps, rate 22.5 and spatial phase 0.2 per unit: the values of the first host this wave was fitted to. */
export const SHAKE_WAVE_DEFAULT: ShakeWave = { stepHz: 60, rate: 22.5, spatial: 0.2 };
